document.addEventListener('DOMContentLoaded', function() {
    const url = new URL(window.location.href);
    const tag = url.searchParams.get('tag');
    const recipient = 'support@aeitto.com';

    if (url.searchParams.has('sendemail')) {
        let subject, body;
        
        if (!tag) {
            subject = 'I need help with my juicer';
            body = 'Hello, my order number is 【】（please fill in the order to quickly activate the warranty）, I have encountered some problems with my juicer and I need help.';
        } else if (tag === 'icemaker') {
            subject = 'Assistance Required with Ice Maker';
            body = 'Hello, I am reaching out regarding an issue with my ice maker Order # 【Your Order Number】（please fill in the order to quickly activate the warranty）. I have encountered some problems with my Ice Maker and I need help.';
        }

        if (subject && body) {
            const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.location.href = mailtoLink;
        }
    }
});

 
 